var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[(!this.$store.getters.isLoading)?_c('router-view'):_c('Loading',{attrs:{"opacity":"1"}}),(this.$store.getters.notifications.length)?_c('SnackbarNotification'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }